import { render } from "./app-form-payment-gateway-method-channel.vue?vue&type=template&id=5355e904"
import script from "./app-form-payment-gateway-method-channel.vue?vue&type=script&lang=js"
export * from "./app-form-payment-gateway-method-channel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/reference/app-form-payment-gateway-method-channel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5355e904"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5355e904', __exports__)) {
    console.log('reload')
    api.reload('5355e904', __exports__)
  }
  
  module.hot.accept("./app-form-payment-gateway-method-channel.vue?vue&type=template&id=5355e904", () => {
    console.log('re-render')
    api.rerender('5355e904', render)
  })

}


export default __exports__